import { combineEpics } from 'redux-observable';

import fetchContractsEpic from './fetchContracts.epic';
import handleDuplicitNolEpic from './handleDuplicitNol.epic';

export default combineEpics(fetchContractsEpic, handleDuplicitNolEpic);
